import React, { useState, useEffect, useMemo } from 'react';
import {
  Typography,
  Checkbox,
  Grid,
  Paper,
  Box,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Link,
  Toolbar,
  Button, Divider, Stack
} from '@mui/material';
import ReactDOMServer from 'react-dom/server';
import { MapContainer, TileLayer, Marker, Popup, GeoJSON, useMap, CircleMarker, WMSTileLayer } from 'react-leaflet';
import FigureCard from '../components/FigureCard';
import { ReactComponent as CamelIcon } from '../assets/logo/camel-svgrepo-com.svg';
import { ReactComponent as GoatIcon } from '../assets/logo/capricorn-svgrepo-com.svg';
import { ReactComponent as CattleIcon } from '../assets/logo/cow-silhouette-svgrepo-com.svg';
import { ReactComponent as DonkeyIcon } from '../assets/logo/donkey-svgrepo-com.svg';
import { ReactComponent as TankersIcon } from '../assets/logo/water-truck-svgrepo-com.svg';
import { ReactComponent as BoreholesIcon } from '../assets/logo/vintage-water-pump-svgrepo-com.svg';
import { ReactComponent as FamilyIcon } from '../assets/logo/family-svgrepo-com.svg';
import { blue, red, green } from '@mui/material/colors';
import { Autocomplete, TextField } from '@mui/material';
import BHFunctionChart from '../components/BHFunctionChart';
import MalfunctionReasonChart from '../components/MalfunctionReasonChart';
import TopBoreholeChart from '../components/TopBoreholeChart';
import MonthlyAnalysisChart from '../components/MonthlyAnalysisChart';
import ReactApexChart from 'react-apexcharts';
import ChartWithSlider from '../components/TimeSliderChart';
import PopupTabs from '../components/PopupTabs';
import dayjs from 'dayjs';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import SaveIcon from '@mui/icons-material/Save';
import SpeedDial from '@mui/material/SpeedDial';
import FunctionsIcon from '@mui/icons-material/Functions';
import RawOnIcon from '@mui/icons-material/RawOn';
import api from '../utils/api';

import LinearProgress from '@mui/material/LinearProgress';
import Backdrop from '@mui/material/Backdrop';


import L from 'leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';

// logo
import euFlag from '../assets/logo/en-v-co-funded-by-pos.png';
import wbLogo from '../assets/logo/world-bank-logo_0.jpg';
import canLogo from '../assets/logo/canada-wordmark.jpg';
import gcfLogo from '../assets/logo/csm_gcf_logo_0863b99f34.png';
import italianLogo from '../assets/logo/Italian-Cooperation_logo.jpg';
import sdcLogo from '../assets/logo/SDC_2.jpg';
import frenchLogo from '../assets/logo/french logo.jpg';
import foreignLogo from '../assets/logo/FCDO_logo_960x640.png';

const REGION_OPTIONS = ['Gedo', 'Bay', 'Bakool', 'Hiraan', 'Mudug', 'Galgaduud'];
const SELECT_ALL = 'Select All';

function Dashboard () {
  const tserved_loading = {
    camel_tot:0,
    sheep_tot:0,
    cattle_tot:0,
    donkey_tot:0,
    tankers_tot:0
  }; 

  const tfunction_loading = {
    yes_count:0,
    no_count:0,
  }

  const [targetServed, setTargetServed] = useState(tserved_loading);
  const [bhFuntional, setBhFuntional] = useState(tfunction_loading);

  const [minTime, setMinTime] = useState(null);
  const [maxTime, setMaxTime] = useState(null);
  const [range, setRange] = useState([minTime, maxTime]);
  const [monthYear, setMonthYear] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedDistricts, setSelectedDistricts] = useState([]);

  const [boreholesPoints, setBoreholesPoints] = useState([]);
  const [brokenBoreholes, setBrokenBoreholes] = useState([]);
  const [fixedBoreholes, setFixedBoreholes] = useState([]);

  const [downloading, setDownloading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [determinate, setDeterminate] = useState(false);
  const [layerMode, setLayerMode] = useState('all')

  const [showReservoirs, setShowReservoirs] = useState(true);
  const [showWaterSources, setShowWaterSources] = useState(true);
  const [wmsOpacity, setWmsOpacity] = useState(0.7);
  
  const allFeatures = boreholesPoints?.features ?? [];

  const visibleFeatures =
    // layerMode === 'fixed_broken' ? allFeatures.filter(f => brokenCodes.has(f?.properties?.borehole_code)) :
    // layerMode === 'broken_fixed' ? allFeatures.filter(f => fixedCodes.has(f?.properties?.borehole_code)) :
    // layerMode === 'not_functional' ? allFeatures.filter(f => f.properties?.status === 'Not Functional') :
    layerMode === 'fixed_broken' ? allFeatures.filter(f => f.properties?.is_broken) :
    layerMode === 'broken_fixed' ? allFeatures.filter(f => f.properties?.is_fixed) :
    layerMode === 'broken_long' ? allFeatures.filter(f => f.properties?.is_longBroken) :
    allFeatures;

  const downloadWithProgress = async (format) => {
    const params = new URLSearchParams({
      start: new Date(range[0]).toISOString().slice(0,10),
      end:   new Date(range[1]).toISOString().slice(0,10),
      region:   JSON.stringify(selectedRegions ?? []),
      district: JSON.stringify(selectedDistricts ?? []),
      req_flag:'download'
    });
    
    let url='';
    if (format==='summary'){
      url = `${process.env.REACT_APP_API_BASE_URL}borehole-point-status?${params.toString()}`;
    } else {
      url = `${process.env.REACT_APP_API_BASE_URL}borehole-raw-data?${params.toString()}`;
    }

    setDownloading(true);
    setProgress(0);
    setDeterminate(false);

    const res = await fetch(url, {
      // headers: { Authorization: `Bearer ${token}` },
      // credentials: 'include',
    });

    if (!res.ok) {
      setDownloading(false);
      console.error(`Download ${format} failed`, res.status);
      return;
    }

    const total = Number(res.headers.get('Content-Length') || 0);
    if (total > 0) setDeterminate(true);

    const reader = res.body.getReader();
    let received = 0;
    const chunks = [];

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      chunks.push(value);
      received += value.byteLength;
      if (total > 0) setProgress(Math.round((received / total) * 100));
    }

    const blob = new Blob(chunks, {
      type: format === 'csv'
        ? 'text/csv;charset=utf-8'
        : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `boreholes_${params.get('start')}_${params.get('end')}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(a.href), 1000);

    setDownloading(false);
  };


  function legendUrl({ layer, style, fontSize = 9, width = 14, height = 14 }) {
    const params = new URLSearchParams({
      service: "WMS",
      request: "GetLegendGraphic",
      version: "1.3.0",
      format: "image/png",
      sld_version: "1.1.0",
      layer,
      // style,
      width: String(width),
      height: String(height),
      transparent: "true",
      // Show only rules that actually draw, force rule labels, and make labels small
      LEGEND_OPTIONS: `hideEmptyRules:true;forceLabels:on;fontSize:${fontSize}`,
    });
    // Note: PUBLIC url must be configured on GeoServer/GeoNode so this isn't localhost
    return `${process.env.REACT_APP_GEOSERVER_WMS}?${params.toString()}`;
  }

  function parsePythonArrayString(s) {
    if (Array.isArray(s)) return s;           // already an array
    if (typeof s !== 'string') return [];

    const jsonish = s
      .replace(/\bNone\b/g, 'null')
      .replace(/\bTrue\b/g, 'true')
      .replace(/\bFalse\b/g, 'false')
      // keys: {'key': ...} -> {"key": ...}
      .replace(/([{,]\s*)'([^']+)'\s*:/g, '$1"$2":')
      // string values: ...: 'val' -> ...: "val"
      .replace(/:\s*'([^']*)'/g, ':"$1"');

    try {
      return JSON.parse(jsonish);
    } catch {
      return [];
    }
  }

  const actions = [
    { icon: <FunctionsIcon />, name: 'Summary', onClick: () => downloadWithProgress('summary') },
    { icon: <RawOnIcon />, name: 'Raw', onClick: () => downloadWithProgress('raw')  },
  ];

  useEffect(() => {
    if (range[0] != null) {
      const controller = new AbortController();
      const start_date = new Date(range[0]).toISOString().slice(0, 10);
      const end_date = new Date(range[1]).toISOString().slice(0, 10);
      const monthsParam = monthYear.join(','); 
      api.get('borehole-point-status/', {
        params: { 
          start: start_date, 
          end: end_date,
          region:JSON.stringify(selectedRegions),
          district:JSON.stringify(selectedDistricts),
          months : monthsParam 
        },
        signal: controller.signal
      })
      .then(res => {
        const safeParse = (v) => (typeof v === 'string' ? JSON.parse(v) : v);

        const brokenRaw = safeParse(res.data.broken);
        const fixedRaw  = safeParse(res.data.fixed);
        const longBrokenRaw  = safeParse(res.data.longbroken);

        // Accept either FeatureCollection or plain array
        const toArray = (x) =>
          Array.isArray(x?.features) ? x.features
          : Array.isArray(x)         ? x
          : [];

        const brokenArr = toArray(brokenRaw);
        const fixedArr  = toArray(fixedRaw);
        const longBrokenArr  = toArray(longBrokenRaw);

        // Build fast lookups by borehole_code
        const toMapByCode = (arr) => {
          const m = new Map();
          for (const it of arr) {
            const props = it.properties ?? it;
            const code = props?.borehole_code;
            if (code) m.set(code, props); // keep props only (or store whole feature if you prefer)
          }
          return m;
        };

        const brokenMap = toMapByCode(brokenArr);
        const fixedMap  = toMapByCode(fixedArr);
        const longBrokenMap  = toMapByCode(longBrokenArr);

        // 2) Enrich the main points with attachments + broken/fixed flags
        const features = res.data.points.features.map((feat) => {
          const props = feat.properties || {};

          // attachments: parse if it’s a JSON string
          let reg_attachments = props.reg_attachments;
          if (typeof reg_attachments === 'string') {
            try { reg_attachments = JSON.parse(reg_attachments); } catch { reg_attachments = []; }
          }

          const code = props.borehole_code;
          const brokenInfo = code ? brokenMap.get(code) : null;
          const fixedInfo  = code ? fixedMap.get(code)  : null;
          const longBrokenInfo  = code ? longBrokenMap.get(code)  : null;

          return {
            ...feat,
            properties: {
              ...props,
              reg_attachments,
              is_broken: Boolean(brokenInfo),
              is_fixed:  Boolean(fixedInfo),
              is_longBroken:  Boolean(longBrokenInfo),
              // optional: bring selected fields from the side layers
              broken_info: brokenInfo || null,
              fixed_info:  fixedInfo  || null,
              longBroken_info:  longBrokenInfo  || null,
              // optional: a tag you can filter on
              layerTag: brokenInfo ? 'broken' : fixedInfo ? 'fixed' : 'normal',
            },
          };
        });

        // console.log(features);

        // 3) Save as a proper FeatureCollection (keep geometry intact)
        setBoreholesPoints({ type: 'FeatureCollection', features });
      })
      .catch(err => console.error('Failed to fetch GeoJSON', err));
      return () => controller.abort();
    }
  }, [monthYear, selectedRegions, selectedDistricts]);

  useEffect(() => {
    if (range[0] != null) {
      const controller = new AbortController();
      let start_date = new Date(range[0]).toISOString().slice(0, 10);
      let end_date = new Date(range[1]).toISOString().slice(0, 10);
      const monthsParam = monthYear.join(','); 
      api.get('target-water-served/',{
        params: {
          start: start_date,
          end: end_date,
          region:JSON.stringify(selectedRegions),
          district:JSON.stringify(selectedDistricts),
          months : monthsParam
        },
        signal: controller.signal
      })
        .then((res) => {
          const data = JSON.parse(res.data).map((item, index) => ({
              ...item,
          }));
          setTargetServed(data[0]);
        })
        .catch((err) => {
          console.error('Failed to fetch reports:', err);
        });
        return () => {
          controller.abort();
        };
    }
  }, [monthYear, selectedRegions, selectedDistricts]);

  useEffect(() => {
    if (range[0] != null) {
      const controller = new AbortController();
      let start_date = new Date(range[0]).toISOString().slice(0, 10);
      let end_date = new Date(range[1]).toISOString().slice(0, 10);
      const monthsParam = monthYear.join(','); 
      api.get('borehole-functional/',{
        params: {
          start: start_date,
          end: end_date,
          region:JSON.stringify(selectedRegions),
          district:JSON.stringify(selectedDistricts),
          months : monthsParam
        },
        signal: controller.signal
      })
        .then((res) => {
          const data = JSON.parse(res.data).map((item, index) => ({
              ...item,
          }));
          // console.log(data[0]);
          setBhFuntional(data[0]);
        })
        .catch((err) => {
          console.error('Failed to fetch reports:', err);
        });
        return () => {
          controller.abort();
        };
    }
  }, [monthYear, selectedRegions, selectedDistricts]);

  const handleChange = (event, value) => {
    if (value.includes(SELECT_ALL)) {
      if (selectedRegions.length === REGION_OPTIONS.length) {
        setSelectedRegions([]);
      } else {
        setSelectedRegions(REGION_OPTIONS);
      }
    } else {
      setSelectedRegions(value);
    }
  };

  const getDisplayOptions = () => {
    if (REGION_OPTIONS.length === 0) return [];
    return [SELECT_ALL, ...REGION_OPTIONS];
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr; // fallback if not a valid date
    // Format: 6 Aug 2025
    return d.toLocaleDateString('en-GB', {
      day: 'numeric', month: 'short', year: 'numeric'
    });
  };


  const onEachFeature = (feature, layer) => {
    if (feature.properties) {
      const props = feature.properties;
      const popupContent = ReactDOMServer.renderToStaticMarkup(
        <PopupTabs props={feature.properties} />
      );
      layer.bindPopup(popupContent);
    }
  };

  const pointToLayer = (feature, latlng) => {
    const status = feature.properties.status;
    let fillColor = 'gray';

    if (status === 'Functional') fillColor = 'green';
    else if (status === 'Not Functional') fillColor = 'red';

    return L.circleMarker(latlng, {
      radius: 3,
      fillColor: fillColor,
      color: '#000',
      weight: 1,
      opacity: 1,
      fillOpacity: 0.8
    });
  };

  const createClusterIcon = (cluster) =>
    L.divIcon({
      html: `<div class="bh-cluster">${cluster.getChildCount()}</div>`,
      className: 'bh-cluster-wrap',
      iconSize: L.point(24, 24, true),
  });

  const iconCache = new Map();
  const dotIcon = (color) => {
    if (!iconCache.has(color)) {
      iconCache.set(
        color,
        L.divIcon({
          className: 'bh-dot-icon',
          html: `<span style="background:${color}"></span>`,
          iconSize: [10, 10], // visual size
          iconAnchor: [5, 5], // center it
        })
      );
    }
    return iconCache.get(color);
  };

  const isAllSelected = selectedRegions.length === REGION_OPTIONS.length;

  const regions = ['Gedo', 'Bay', 'Bakool', 'Hiraan', 'Mudug', 'Galgaduud'];
  const SELECT_ALL = 'Select All';
  
  return (
  <Box
    sx={{
      maxWidth: 1365,
      mx: 'auto',
      px: 2,
      py: 2,
      backgroundColor:'white',
    }}
  >
    <Grid container spacing={0.5} sx={{ mb: 1, display: 'flex', justifyContent: 'flex-end', }}>
        <SpeedDial
          ariaLabel="SpeedDial basic example"
          // sx={{ position: 'absolute', bottom: 16, right: 16 }}
          icon={<CloudDownloadIcon />}
          direction={'left'}
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              onClick={action.onClick}
              slotProps={{
                tooltip: {
                  title: action.name,
                },
              }}
            />
          ))}
        </SpeedDial>
        <Backdrop open={downloading} sx={{ color: '#fff', zIndex: (t) => t.zIndex.modal + 1 }}>
          <Box sx={{ width: 360, p: 2, borderRadius: 2, bgcolor: 'background.paper', color: 'text.primary', boxShadow: 3 }}>
            <Typography sx={{ mb: 1 }}>
              {determinate ? `Downloading… ${progress}%` : 'Preparing download…'}
            </Typography>
            <LinearProgress variant={determinate ? 'determinate' : 'indeterminate'} value={progress} />
          </Box>
        </Backdrop>
    </Grid>
    <Grid container spacing={0.5} sx={{ mb: 1 }}>
      {[
        { title: 'Household Served', figure: targetServed.household_tot, color: blue[500], icon: FamilyIcon },
        { title: 'Camel Served', figure: targetServed.camel_tot, color: blue[500], icon: CamelIcon },
        { title: 'Goat/Sheep Served', figure: targetServed.sheep_tot, color: blue[500], icon: GoatIcon },
        { title: 'Cattle Served', figure: targetServed.cattle_tot, color: blue[500], icon: CattleIcon },
        { title: 'Donkey Served', figure: targetServed.donkey_tot, color: blue[500], icon: DonkeyIcon },
        { title: 'Tankers Served', figure: targetServed.tankers_tot, color: blue[500], icon: TankersIcon },
        { title: 'Functioning Bhs', figure: bhFuntional.yes_count, color: green[500], icon: BoreholesIcon },
        { title: 'Non-Functioning Bhs', figure: bhFuntional.no_count, color: red[500], icon: BoreholesIcon },
      ].map((it, i) => (
        <Grid 
          // size={{ xs: 1, sm:1, md:1, lg:1 }} 
          key={i}
        >
          <FigureCard {...it} />
        </Grid>
      ))}
    </Grid>
    <Toolbar
      sx={{
        backgroundColor: 'white',
        // borderRadius: 2,
        gap: 2,
        mt: 1,
        mb: 1,
        flexWrap: 'wrap',
        // border:1,
        boxShadow: 2
      }}
    >

      <ChartWithSlider sx={{ width: '100%' }} minTime={minTime} maxTime={maxTime} setMinTime={setMinTime} setMaxTime={setMaxTime} range={range} setRange={setRange} monthYear={monthYear} setMonthYear={setMonthYear} selectedRegions={selectedRegions} selectedDistricts={selectedDistricts} />
      <Box sx={{ display:'flex', alignItems:'center', gap:2, ml:'auto' }}>
        <label style={{ fontSize: 11 }}><Checkbox checked={showReservoirs} onChange={e=>setShowReservoirs(e.target.checked)} />
            <img
            alt="Reservoirs legend"
            src={legendUrl({
              layer: "geonode:reservoirs",
              fontSize: 9,
              width: 20, height: 20
            })}
            style={{
              height: 20,
              imageRendering: 'pixelated',
              position:'relative',
              top:8
            }}
          />
        </label>
        <label style={{ fontSize: 11 }}><Checkbox checked={showWaterSources} onChange={e=>setShowWaterSources(e.target.checked)} />
          <img
            alt="Not Monitored Borreholes legend"
            src={legendUrl({
              layer: "geonode:all_watersources",
              fontSize: 9,
              width: 20, height: 20
            })}
            style={{
              height: 20,
              imageRendering: 'pixelated',
              position:'relative',
              top:8
            }} />
        </label>
        <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
          <Typography style={{ fontSize: 11 }} variant="caption">Opacity</Typography>
          <input type="range" min={0} max={1} step={0.05} value={wmsOpacity} onChange={(e)=>setWmsOpacity(parseFloat(e.target.value))} />
      </Box>
    </Box>
    </Toolbar> 
    {/* Map Section */}
    <Box sx={{ px: 0, pb: 1, pt: 0, display: 'flex', gap: 1, flexWrap: 'wrap'}}>
        <Box sx={{ maxWidth: 550, px: 0, pb: 1, pt: 0, flex: 2 }}>
            <Box sx={{ height: 740, borderRadius: 0, overflow: 'hidden', boxShadow: 2 }}>
                <MapContainer
                  center={[2.0469, 45.3182]}
                  zoom={6}
                  scrollWheelZoom={true}
                  style={{ height: '100%', width: '100%' }}
                >
                <TileLayer
                    attribution='&copy; OpenStreetMap contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {/* ====== WMS: Reservoir polygons ====== */}
                {showReservoirs && (
                  <WMSTileLayer
                    url={`${process.env.REACT_APP_GEOSERVER_WMS}`}
                    format="image/png"
                    transparent
                    version="1.1.0"
                    // ganti workspace:layerName sesuai GeoServer kamu
                    layers="geonode:reservoirs"
                    // styles="reservoirs"            // pakai SLD yang sudah kamu upload (opsional)
                    opacity={wmsOpacity}
                    tiled
                    // contoh CQL filter berdasarkan pilihan user:
                    // params={{
                    //   CQL_FILTER:
                    //     selectedRegions.length
                    //       ? `region IN (${selectedRegions.map(r=>`'${r.replace(/'/g,"''")}'`).join(",")})`
                    //       : undefined
                    // }}
                    zIndex={300}                   // di atas base map
                  />
                )}

                {/* ====== WMS: All water sources (points) ====== */}
                {showWaterSources && (
                  <WMSTileLayer
                    url={`${process.env.REACT_APP_GEOSERVER_WMS}`}
                    format="image/png"
                    transparent
                    version="1.1.0"
                    layers="geonode:all_watersources"  // ganti sesuai nama layer di GeoServer
                    // styles="all_watersources_by_type" // SLD kategori water_source_type (opsional)
                    opacity={wmsOpacity}
                    tiled
                    // params={{
                    //   // contoh filter kombinasi region & district
                    //   CQL_FILTER: [
                    //     selectedRegions.length
                    //       ? `region IN (${selectedRegions.map(r=>`'${r.replace(/'/g,"''")}'`).join(",")})`
                    //       : null,
                    //     selectedDistricts.length
                    //       ? `district IN (${selectedDistricts.map(d=>`'${d.replace(/'/g,"''")}'`).join(",")})`
                    //       : null
                    //   ].filter(Boolean).join(' AND ') || undefined
                    // }}
                    zIndex={310}
                  />
                )}
                <MarkerClusterGroup
                  chunkedLoading
                  maxClusterRadius={0}
                  spiderfyOnMaxZoom
                  showCoverageOnHover={true}
                  iconCreateFunction={createClusterIcon}
                >
                {visibleFeatures?.map((feature, idx) => {
                  const [lon, lat] = feature.geometry.coordinates;
                  const status = feature.properties.status;
                  let fillColor = 'gray';
                  if (status === 'Functional') fillColor = 'green';
                  else if (status === 'Not Functional') fillColor = 'red';

                  return (
                    // <CircleMarker
                    //   key={idx}
                    //   center={[lat, lon]}
                    //   radius={3}
                    //   pathOptions={{
                    //     fillColor,
                    //     color: '#000',
                    //     fillOpacity: 0.8,
                    //     weight: 1,
                    //   }}
                    // >
                    //   <Popup minWidth={250}>
                    //     <PopupTabs props={feature.properties} />
                    //   </Popup>
                    // </CircleMarker>
                    <Marker key={idx} position={[lat, lon]} icon={dotIcon(fillColor)}>
                    <Popup minWidth={250}>
                      <PopupTabs props={feature.properties} />
                    </Popup>
                  </Marker>
                  );
                })}
                </MarkerClusterGroup>
                <LegendControl layerMode={layerMode} setLayerMode={setLayerMode} />
                </MapContainer>
            </Box>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {/* <Box sx={{ borderRadius: 2, }}> */}
                <BHFunctionChart range={range} selectedRegions={selectedRegions} setSelectedRegions={setSelectedRegions} selectedDistricts={selectedDistricts} setSelectedDistricts={setSelectedDistricts} monthYear={monthYear}/>
            {/* </Box> */}
            <Box >
                <MalfunctionReasonChart range={range} selectedRegions={selectedRegions} monthYear={monthYear} />
                <TopBoreholeChart range={range} selectedRegions={selectedRegions} selectedDistricts={selectedDistricts} monthYear={monthYear} title={'Top Borehole By Water Trucking'}/>
            </Box>
        </Box>
         
    </Box>

    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        <Box>
               <TopBoreholeChart range={range} selectedRegions={selectedRegions} selectedDistricts={selectedDistricts} monthYear={monthYear}  title={'Top Borehole By Livestock Served'}/>
               <TopBoreholeChart range={range} selectedRegions={selectedRegions} selectedDistricts={selectedDistricts} monthYear={monthYear}  title={'Top Borehole By Household Served'}/>
        </Box>
        <Box>
               <MonthlyAnalysisChart range={range} selectedRegions={selectedRegions} selectedDistricts={selectedDistricts} monthYear={monthYear}/>
        </Box>
    </Box>


    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pt:3, alignItems:'center' }}>
      <Typography sx={{fontSize:12, borderBottom: '1px solid', borderColor: 'divider', my: 0 }}>
        SWALIM is a multi-donor project managed by FAO and currently funded by The European Union, The World Bank, AICS, SDC, FCDO, Canada and GCF
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0, pt:0, alignItems:'center', borderBottom: '1px solid', borderColor: 'divider', my: 0}}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{ pt: 0 }}
        >

            <Box
              component="img"
              src={euFlag}
              sx={{
                width: 120,        
                // height: 80,
                objectFit: 'cover',
                borderRadius: 1,
                boxShadow: 0,
                display: 'block'
              }}
            />

            <Box
              component="img"
              src={wbLogo}
              sx={{
                width: 175,        
                // height: 80,
                objectFit: 'cover',
                borderRadius: 1,
                boxShadow: 0,
                display: 'block'
              }}
            />

            <Box
              component="img"
              src={italianLogo}
              sx={{
                width: 120,        
                // height: 100,
                objectFit: 'cover',
                borderRadius: 1,
                boxShadow: 0,
                display: 'block'
              }}
            />

            <Box
              component="img"
              src={sdcLogo}
              sx={{
                width: 250,        
                // height: 80,
                objectFit: 'cover',
                borderRadius: 1,
                boxShadow: 0,
                display: 'block'
              }}
            />

            <Box
              component="img"
              src={foreignLogo}
              sx={{
                width: 200,        
                // height: 80,
                objectFit: 'cover',
                borderRadius: 1,
                boxShadow: 0,
                display: 'block'
              }}
            />

            <Box
              component="img"
              src={canLogo}
              sx={{
                width: 120,        
                // height: 80,
                objectFit: 'cover',
                borderRadius: 1,
                boxShadow: 0,
                display: 'block'
              }}
            />

            <Box
              component="img"
              src={gcfLogo}
              sx={{
                width: 120,        
                // height: 80,
                objectFit: 'cover',
                borderRadius: 1,
                boxShadow: 0,
                display: 'block'
              }}
            />

        </Stack>
        
      </Box>
      <Typography sx={{fontSize:12 }}>
        © SWALIM - Thorn Tree Lodge, AAIA, Mogadishu | Red Sea area, Hargeisa, Somaliland | UNCC Garowe, Puntland | swalim@fao.org
      </Typography>
    </Box>

  </Box>




  
)};

const LegendControl = ({ layerMode, setLayerMode }) => {
  const map = useMap();
  const selectId = React.useRef(`legend-select-${Math.random().toString(36).slice(2)}`);

  React.useEffect(() => {
    const legend = L.control({ position: 'bottomright' });

    legend.onAdd = function () {
      const div = L.DomUtil.create('div', 'info legend');
      // basic styling
      Object.assign(div.style, {
        background: 'white',
        padding: '10px 12px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        font: '12px/1.2 system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
      });

      div.innerHTML = `
        <div style="font-weight:600; margin-bottom:6px;">Borehole Status</div>
        <ul style="list-style:none; padding:0; margin:0 0 8px 0;">
          <li style="display:flex; align-items:center; gap:8px; margin-bottom:4px;">
            <i style="background:green; width:14px; height:14px; display:inline-block; border-radius:3px;"></i>
            <span>Functional</span>
          </li>
          <li style="display:flex; align-items:center; gap:8px;">
            <i style="background:red; width:14px; height:14px; display:inline-block; border-radius:3px;"></i>
            <span>Not Functional</span>
          </li>
        </ul>
        <label style="display:block; font-weight:600; margin-bottom:4px;">Borehole Filter</label>
        <select id="${selectId.current}" style="width:190px; padding:4px 6px;">
          <option value="all">All</option>
          <option value="broken_fixed">Recently fixed</option>
          <option value="fixed_broken">Recently broken</option>
          <option value="broken_long">Long time broken</option>
        </select>
      `;

      // don’t block map interactions outside the legend
      L.DomEvent.disableClickPropagation(div);
      L.DomEvent.disableScrollPropagation(div);

      return div;
    };

    legend.addTo(map);

    const sel = document.getElementById(selectId.current);
    if (sel) {
      sel.value = layerMode;
      const onChange = (e) => {
        // console.log(e.target.value);
        setLayerMode(e.target.value);
      };
      sel.addEventListener('change', onChange);

      // cleanup
      return () => {
        sel.removeEventListener('change', onChange);
        legend.remove();
      };
    }

    return () => legend.remove();
  }, [map]); // create once

  // keep the select synchronized if layerMode changes from outside
  React.useEffect(() => {
    const sel = document.getElementById(selectId.current);
    if (sel && sel.value !== layerMode) sel.value = layerMode;
  }, [layerMode]);

  return null;
};

export default Dashboard;